import dayjs from 'dayjs';
import jsonata from 'jsonata';
import Cookies from 'js-cookie';
import _ from 'lodash';
import moment from 'moment';

const jsonnataInstances = new Map();

export function getJsonAta(str: string) {
  let ins = jsonnataInstances.get(str);
  if (!ins) {
    try {
      ins = jsonataFactory(str);
      jsonnataInstances.set(str, ins);
    } catch (e) {
      console.error('规则创建失败', e);
    }
  }
  const evaluate = (...arg: any) => {
    return ins?.evaluate(...arg);
  };
  return {
    evaluate,
  };
}

export function jsonataFactory(exp: string) {
  const exCal = jsonata(exp);
  exCal.registerFunction('day', (data) => {
    if (!data) {
      return 0;
    }
    return dayjs(data).diff(dayjs('2000-01-01'), 'days');
  });
  exCal.registerFunction('num', (data) => {
    if (_.isNumber(data) || _.isString(data)) {
      return isNaN(Number(data)) ? 0 : Number(data);
    }
    return new Error();
  });
  exCal.registerFunction('userAccount', () => {
    return Cookies.get('userAccount');
  });
  exCal.registerFunction('userName', () => {
    return Cookies.get('userName');
  });
  exCal.registerFunction('taskId', () => {
    return window.pageProps?.taskId;
    // const taskIdMatch = window.location.pathname.match(/TASK[0-9]+/);
    // return taskIdMatch ? taskIdMatch[0] : null;
  });
  exCal.registerFunction('searchParams', (name: string) => {
    if (!name) {
      return null;
    }
    // 优先获取在顶层写入到window上的参数
    const params: any = window.pageProps?.utils?.queryParams || Object.fromEntries(new URLSearchParams(window.location.search));
    return params[name];
  });
  exCal.registerFunction('pageType', (name: string) => {
    return window.pageProps?.pageType;
  });
  // $moment(['hour', 12], ['minute', 12]) moment 的函数调用
  exCal.registerFunction('moment', (...arg) => {
    let time = moment();
    arg.forEach(item => {
      if (_.isArray(item)) {
        const [funcName, ...funcArgs] = item;
        time = time[funcName]?.(...funcArgs);
      }
    });
    return time;
  });
  return exCal;
}

/**
 * 基于文本生成值
 * @param exp 表达式文本
 * @returns any
 */
export function getExpressionsValue(exp?: string) {
  if (!exp) {
    return;
  }
  if (/\$[a-z_A-Z0-9]+\(.*\)/.test(exp)) {
    const expression = jsonataFactory(exp);
    return expression.evaluate({});
  } else {
    return exp;
  }
}
